// import Linje from "../../components/pages/linje/id/Linje";
import { useContext, useState } from "react";
import PageTitle from "@/components/PageTitle";
import Button from "@/components/bricks/button/Button";
import ArrowLeftIcon from "../../components/icons/ArrowLeftIcon";
import KursusIcon from "../../components/icons/KursusIcon";
import {
  DropdownContent,
  DropdownItem,
  DropdownRoot,
  DropdownTrigger,
} from "../../components/dropdown/Dropdown";
import CheckIcon from "../../components/icons/CheckIcon";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_LINJE_BY_ID_QUERY } from "../../api/linje/queries";
import Spinner from "../../components/spinner/Spinner";
import {
  // PagedLinjeContext,
  PagedLinjeQueryContext,
} from "../../context/PagedLinjeQueryProvider";
import { IDPagination } from "../../components/pagination/IDPagination";
// import { QUERY_PAGE_SIZE } from "../../api/util";
import Sidebar from "../../components/pages/linje/id/Sidebar";
import { dateToyyyyMMdd } from "../../util/date";
import {
  TabsContent,
  TabsList,
  TabsRoot,
  TabsTrigger,
} from "../../components/tabs/Tabs";
import LinjeKurser from "../../components/pages/linje/id/Kurser/LinjeKurser";
import { AccordionCard } from "../../components/accordion/Accordion";
import Linjeoplysninger from "../../components/pages/linje/id/Linjeoplysninger";
import LinjeKursister from "../../components/pages/linje/id/Kursister/LinjeKursister";
import { Fmulinje } from "../../interfaces/schema";
import { transformQueryDataPerioder } from "../../util/apollo";

export default function LinjeById() {
  // navigation
  const params = useParams();
  const { id } = params;
  const navigate = useNavigate();

  // context
  const pagedLinjeQueryContext = useContext(PagedLinjeQueryContext);

  // load some stuff
  const [data, setData] = useState<
    | {
        fmulinje: Fmulinje;
      }
    | undefined
  >(undefined);
  const { loading, error, refetch } = useQuery<{ fmulinje: Fmulinje }>(
    GET_LINJE_BY_ID_QUERY(),
    {
      variables: { id, dato: dateToyyyyMMdd(new Date()) },
      notifyOnNetworkStatusChange: true,
      onCompleted: (d) => {
        const transformed = transformQueryDataPerioder(d);
        setData(transformed);
      },
    },
  );
  if (loading) return <Spinner />;
  if (error) return <div>noget gik galt 😔</div>;
  if (!data) return null;
  const { fmulinje } = data;
  if (!fmulinje) return <div>Ingen linje fundet 😯</div>;

  // 4 testing

  return (
    <div className="l-main__content">
      <PageTitle />
      <header className="navbar navbar--sub">
        <div className="col d-flex align-items-center gap-3">
          <Button
            icon
            color="secondary"
            aria-label="Tilbage"
            onClick={() => {
              navigate("/linje");
            }}
          >
            <ArrowLeftIcon />
          </Button>
          <h2 className="mx-1 d-flex align-items-center gap-2">
            <span className="me-1 mt-n1">
              <KursusIcon height={26} />
            </span>
            {fmulinje.navn}
            <span className="text-secondary h5 align-self-end fw-semibold lh-base">
              Linje
            </span>
          </h2>
          <div className="col d-flex align-items-center justify-content-end gap-5">
            <DropdownRoot className="c-dropdown-default--actions">
              <DropdownTrigger>
                <span className="badge badge--fixed-size ms-n2">
                  <span className="ms-n2">
                    <CheckIcon />
                  </span>
                  <span>Aktuel linje</span>
                </span>
                <span className="fw-semibold">Handlinger</span>
              </DropdownTrigger>
              <DropdownContent>
                <DropdownItem>
                  <span>Item 1</span>
                </DropdownItem>
                <DropdownItem>
                  <span>Item 2</span>
                </DropdownItem>
              </DropdownContent>
            </DropdownRoot>
            <IDPagination
              pagedContext={pagedLinjeQueryContext}
              currentSelection={fmulinje}
            />
          </div>
        </div>
      </header>
      <div className="l-main-row">
        <Sidebar fmulinje={fmulinje} />
        <main className="col overflow-hidden">
          <TabsRoot
            defaultValue="stamoplysninger"
            localStorageKey="linje-id-tabs"
          >
            <TabsList>
              <div className="container">
                <TabsTrigger value="stamoplysninger">
                  Stamoplysninger
                </TabsTrigger>
                <TabsTrigger value="deltagere">Deltagere</TabsTrigger>
              </div>
            </TabsList>
            <TabsContent value="stamoplysninger">
              <div className="container">
                <Linjeoplysninger
                  fmulinje={fmulinje}
                  refetch={
                    (() => {
                      refetch();
                    }) as any
                  }
                />
                <AccordionCard
                  localstorageKey="linje-id-stamoplysninger-accordion-value"
                  title="Kurser"
                  value="kurser"
                  isEmpty={false}
                >
                  <LinjeKurser fmulinje={fmulinje} />
                </AccordionCard>
              </div>
            </TabsContent>
            <TabsContent value="deltagere">
              <LinjeKursister id={fmulinje.id} />
            </TabsContent>
          </TabsRoot>
          {/* <div className="c-tabs">
            <div className="tab__content">
              <Linje
                editMode={editMode}
                setEditMode={setEditMode}
                fmulinje={fmulinje}
                refetch={refetch}
              />
            </div>
          </div> */}
        </main>
      </div>
    </div>
  );
}
